import { isObjectOrNull, matchesObject } from '../utils'

/**
 * returns true if action's meta value matches target.
 * uses strict equality for matching property values.
 * useful for testing action against expected `meta` property when action's `type` isn't sufficient.
 * @alias module:core
 * @param {{}} action the action (FSA) to test
 * @param {{}} meta expected meta object for match
 * @param {function} [getKeys=Reflect.ownKeys] custom method to determine matchable properties
 * @param {number} [maxLevel=2] max object depth for matching algorithm. defaults to `2`
 * @return {boolean} returns `true` for match, `false` otherwise
 */
const matchesMeta = (action, meta, getKeys, maxLevel) => {
  if (isObjectOrNull(meta)) {
    return matchesObject(action.meta, meta || {}, getKeys, maxLevel)
  }
  return action.meta === meta
}

export default matchesMeta

/**
 * Configurable version of matchesMeta.
 * Accepts `options` and returns a function which calls matchesMeta using those options.
 * @alias module:core
 * @param {{}} options apiActionTypes options
 * @param {{}} [options.defaultMeta={}] default meta to use in result function, when meta arg not supplied
 * @param {function} [options.getKeys] getKeys argument for matchesMeta
 * @param {number} [options.maxLevel=2] maxLevel argument for matchesMeta
 * @return {function} preconfigured matchesMeta function that only accepts 2 arguments (type, meta)
 */
export const configureMatchesMeta = ({
  defaultMeta,
  getKeys,
  maxLevel
} = {}) => (action, meta = defaultMeta) => matchesMeta(action, meta, getKeys, maxLevel)
